import { connect } from 'react-redux'
import { selectSample, changeColors } from '../../actions/index'
import SampleMenu from './sampleMenu'

const mapStateToProps = ( state, props ) => ({
	tile: state.tiles[state.selectedTile],
	selectedTileIndex: state.selectedTile,
	selectedSample: state.selectedSample
});

const mapDispatchToProps = (dispatch, props ) => ({
	onSelectedSample : ( id, colors ) =>  { dispatch( selectSample( id ) ); dispatch( changeColors( colors ) ) }
});

const VisibleSampleMenu = connect( mapStateToProps, mapDispatchToProps)(SampleMenu);

export default VisibleSampleMenu;


// WEBPACK FOOTER //
// ./src/components/mosaic/visibleSampleMenu.jsx